import classNames from 'classnames'
import React, { PropsWithChildren, ReactNode, useMemo } from 'react'

import './ProcessDocumentFileUploadProgress.scss'

interface ProcessDocumentFileUploadProgressIconProps {
  completed: boolean
  failed: boolean
}

export const ProcessDocumentFileUploadProgressIcon: React.FC<ProcessDocumentFileUploadProgressIconProps> = ({ completed, failed }) => {
  if (failed) {
    return (
      <div className='d-flex align-items-center justify-content-center rounded-circle process-document-file-upload-progress-icon-wrapper zocks-bg-color-danger-background'>
        <i className='bi bi-x fs-6 zocks-text-danger' />
      </div>
    )
  }

  if (completed) {
    return (
      <div className='d-flex align-items-center justify-content-center rounded-circle process-document-file-upload-progress-icon-wrapper zocks-bg-color-success-background'>
        <i className='bi bi-check fs-6 zocks-text-success' />
      </div>
    )
  }

  return (
    <div className='d-flex align-items-center justify-content-center process-document-file-upload-progress-icon-wrapper'>
      <div className='rounded-circle process-document-file-upload-progress-icon-content zocks-bg-color-primary' />
    </div>
  )
}

export interface ProgressItem {
  isLoading: boolean
  isSuccess: boolean
  isFailure?: boolean
  label: ReactNode
}

interface ProcessDocumentFileUploadProgressProps {
  items: ProgressItem[]
}

export const ProcessDocumentFileUploadProgress: React.FC<ProcessDocumentFileUploadProgressProps> = ({ items }) => {
  const itemsToShow = useMemo(() => items.filter(({ isLoading, isSuccess, isFailure }) => isLoading || isSuccess || isFailure), [items])

  if (!itemsToShow.length) {
    return null
  }

  return (
    <div className='d-flex flex-column gap-4 p-4 zocks-bg-color-gray-100 zocks-border-0.75'>
      {itemsToShow.map(({ isSuccess, isFailure = false, label }, index) => (
        <div key={index} className='d-flex process-document-file-upload-progress-item zocks-gap-1 position-relative'>
          {index > 0 ? <div className='process-document-file-upload-progress-item-separator zocks-bg-color-gray-200' /> : null}
          <div className='process-document-file-upload-progress-icon-container d-flex align-items-center justify-content-center'>
            <ProcessDocumentFileUploadProgressIcon completed={isSuccess} failed={isFailure} />
          </div>
          {label}
        </div>
      ))}
    </div>
  )
}

interface ProgressItemWrapperProps {
  isLoading?: boolean
}

export const ProgressItemWrapper: React.FC<PropsWithChildren<ProgressItemWrapperProps>> = ({ isLoading = false, children }) => {
  return <span className={classNames('paragraph-medium text-truncate', { 'shimmering-loader-text': isLoading })}>{children}</span>
}
